module.exports = __webpack_public_path__ + "static/media/profile.4971acf9.jpg";